export const parseURL = ( url ) => {
	const searchParams = new URLSearchParams( url.search )
	return searchParams
}